import { default as _91_46_46_46all_930i5ctWJQq5Meta } from "/vercel/path0/pages/[...all].vue?macro=true";
import { default as addressED39XkEx1LMeta } from "/vercel/path0/pages/account/address.vue?macro=true";
import { default as indexqOnLrLMUjLMeta } from "/vercel/path0/pages/account/index.vue?macro=true";
import { default as orderTLe4nSwR9NMeta } from "/vercel/path0/pages/account/order.vue?macro=true";
import { default as paymentV3pkwItuAdMeta } from "/vercel/path0/pages/account/payment.vue?macro=true";
import { default as profileLQWMAtlTUmMeta } from "/vercel/path0/pages/account/profile.vue?macro=true";
import { default as indexR9ItFM3MR2Meta } from "/vercel/path0/pages/account/recover/index.vue?macro=true";
import { default as passwordn5BdmkURowMeta } from "/vercel/path0/pages/account/recover/password.vue?macro=true";
import { default as cartfC7LJBHqlCMeta } from "/vercel/path0/pages/checkout/cart.vue?macro=true";
import { default as indexraiq4bUafSMeta } from "/vercel/path0/pages/checkout/index.vue?macro=true";
import { default as indexDdll4vfR4JMeta } from "/vercel/path0/pages/checkout/success/[id]/index.vue?macro=true";
import { default as paidNswHEDxk6GMeta } from "/vercel/path0/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as unpaid61KGWjv8ShMeta } from "/vercel/path0/pages/checkout/success/[id]/unpaid.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as _91id_93w7RDswVolZMeta } from "/vercel/path0/pages/news/blog/[id].vue?macro=true";
import { default as newsletter_45subscribep2E1MYmvn4Meta } from "/vercel/path0/pages/newsletter-subscribe.vue?macro=true";
import { default as registerIikvtlfpbHMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as reset_45password7wK2GPZgVKMeta } from "/vercel/path0/pages/reset-password.vue?macro=true";
import { default as searchBIFC2dE21WMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as shopwareRPK9liJ28YMeta } from "/vercel/path0/pages/shopware.vue?macro=true";
import { default as wishlistakmJn3oDDeMeta } from "/vercel/path0/pages/wishlist.vue?macro=true";
export default [
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "all___en",
    path: "/en/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "all___de",
    path: "/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "account-address___fr",
    path: "/fr/account/address",
    meta: addressED39XkEx1LMeta || {},
    component: () => import("/vercel/path0/pages/account/address.vue")
  },
  {
    name: "account-address___en",
    path: "/en/account/address",
    meta: addressED39XkEx1LMeta || {},
    component: () => import("/vercel/path0/pages/account/address.vue")
  },
  {
    name: "account-address___de",
    path: "/account/address",
    meta: addressED39XkEx1LMeta || {},
    component: () => import("/vercel/path0/pages/account/address.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexqOnLrLMUjLMeta || {},
    component: () => import("/vercel/path0/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexqOnLrLMUjLMeta || {},
    component: () => import("/vercel/path0/pages/account/index.vue")
  },
  {
    name: "account___de",
    path: "/account",
    meta: indexqOnLrLMUjLMeta || {},
    component: () => import("/vercel/path0/pages/account/index.vue")
  },
  {
    name: "account-order___fr",
    path: "/fr/account/order",
    meta: orderTLe4nSwR9NMeta || {},
    component: () => import("/vercel/path0/pages/account/order.vue")
  },
  {
    name: "account-order___en",
    path: "/en/account/order",
    meta: orderTLe4nSwR9NMeta || {},
    component: () => import("/vercel/path0/pages/account/order.vue")
  },
  {
    name: "account-order___de",
    path: "/account/order",
    meta: orderTLe4nSwR9NMeta || {},
    component: () => import("/vercel/path0/pages/account/order.vue")
  },
  {
    name: "account-payment___fr",
    path: "/fr/account/payment",
    meta: paymentV3pkwItuAdMeta || {},
    component: () => import("/vercel/path0/pages/account/payment.vue")
  },
  {
    name: "account-payment___en",
    path: "/en/account/payment",
    meta: paymentV3pkwItuAdMeta || {},
    component: () => import("/vercel/path0/pages/account/payment.vue")
  },
  {
    name: "account-payment___de",
    path: "/account/payment",
    meta: paymentV3pkwItuAdMeta || {},
    component: () => import("/vercel/path0/pages/account/payment.vue")
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: profileLQWMAtlTUmMeta || {},
    component: () => import("/vercel/path0/pages/account/profile.vue")
  },
  {
    name: "account-profile___en",
    path: "/en/account/profile",
    meta: profileLQWMAtlTUmMeta || {},
    component: () => import("/vercel/path0/pages/account/profile.vue")
  },
  {
    name: "account-profile___de",
    path: "/account/profile",
    meta: profileLQWMAtlTUmMeta || {},
    component: () => import("/vercel/path0/pages/account/profile.vue")
  },
  {
    name: "account-recover___fr",
    path: "/fr/account/recover",
    component: () => import("/vercel/path0/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___en",
    path: "/en/account/recover",
    component: () => import("/vercel/path0/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___de",
    path: "/account/recover",
    component: () => import("/vercel/path0/pages/account/recover/index.vue")
  },
  {
    name: "account-recover-password___fr",
    path: "/fr/account/recover/password",
    component: () => import("/vercel/path0/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___en",
    path: "/en/account/recover/password",
    component: () => import("/vercel/path0/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___de",
    path: "/account/recover/password",
    component: () => import("/vercel/path0/pages/account/recover/password.vue")
  },
  {
    name: "checkout-cart___fr",
    path: "/fr/checkout/cart",
    meta: cartfC7LJBHqlCMeta || {},
    component: () => import("/vercel/path0/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___en",
    path: "/en/checkout/cart",
    meta: cartfC7LJBHqlCMeta || {},
    component: () => import("/vercel/path0/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___de",
    path: "/checkout/cart",
    meta: cartfC7LJBHqlCMeta || {},
    component: () => import("/vercel/path0/pages/checkout/cart.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: indexraiq4bUafSMeta || {},
    component: () => import("/vercel/path0/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: indexraiq4bUafSMeta || {},
    component: () => import("/vercel/path0/pages/checkout/index.vue")
  },
  {
    name: "checkout___de",
    path: "/checkout",
    meta: indexraiq4bUafSMeta || {},
    component: () => import("/vercel/path0/pages/checkout/index.vue")
  },
  {
    name: "checkout-success-id___fr",
    path: "/fr/checkout/success/:id()",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___en",
    path: "/en/checkout/success/:id()",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___de",
    path: "/checkout/success/:id()",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-paid___fr",
    path: "/fr/checkout/success/:id()/paid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___en",
    path: "/en/checkout/success/:id()/paid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___de",
    path: "/checkout/success/:id()/paid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-unpaid___fr",
    path: "/fr/checkout/success/:id()/unpaid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___en",
    path: "/en/checkout/success/:id()/unpaid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___de",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/vercel/path0/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "news-blog-id___fr",
    path: "/fr/news/blog/:id()",
    component: () => import("/vercel/path0/pages/news/blog/[id].vue")
  },
  {
    name: "news-blog-id___en",
    path: "/en/news/blog/:id()",
    component: () => import("/vercel/path0/pages/news/blog/[id].vue")
  },
  {
    name: "news-blog-id___de",
    path: "/news/blog/:id()",
    component: () => import("/vercel/path0/pages/news/blog/[id].vue")
  },
  {
    name: "newsletter-subscribe___fr",
    path: "/fr/newsletter-subscribe",
    component: () => import("/vercel/path0/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter-subscribe",
    component: () => import("/vercel/path0/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___de",
    path: "/newsletter-subscribe",
    component: () => import("/vercel/path0/pages/newsletter-subscribe.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerIikvtlfpbHMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerIikvtlfpbHMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/register",
    meta: registerIikvtlfpbHMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    component: () => import("/vercel/path0/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/vercel/path0/pages/reset-password.vue")
  },
  {
    name: "reset-password___de",
    path: "/reset-password",
    component: () => import("/vercel/path0/pages/reset-password.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "shopware___fr",
    path: "/fr/shopware",
    component: () => import("/vercel/path0/pages/shopware.vue")
  },
  {
    name: "shopware___en",
    path: "/en/shopware",
    component: () => import("/vercel/path0/pages/shopware.vue")
  },
  {
    name: "shopware___de",
    path: "/shopware",
    component: () => import("/vercel/path0/pages/shopware.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    component: () => import("/vercel/path0/pages/wishlist.vue")
  },
  {
    name: "wishlist___en",
    path: "/en/wishlist",
    component: () => import("/vercel/path0/pages/wishlist.vue")
  },
  {
    name: "wishlist___de",
    path: "/wishlist",
    component: () => import("/vercel/path0/pages/wishlist.vue")
  }
]